// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

const BaseTripApiConfigurationAreaRoutes = {
  route: '/trip-api-configuration',
}

export const TripApiConfigurationAreaRoutes = transformRoutes(
  BaseTripApiConfigurationAreaRoutes,
)
